import React from 'react';
import PropTypes from 'prop-types';
import Suggestions from './Suggestions';

export default class Search extends React.Component {
  state = {
    showSuggestions: false
  }

  _toggleSuggestions = bool => {
    this.setState({ showSuggestions: bool });
  }

  onChange = event => {
    if (this.props.value) {
      this.props.setValue(this.props.index, this.props.value.set('name', event.target.value));
    }
    
    this.props._search.setSearchTerm(event.target.value);
    this.props._search.searchForMerchant(this.props.customer.get('location'));
    this._toggleSuggestions(true);
  }

  _handleKeyPress = event => {
    if (event.keyCode === 27) {
      this._toggleSuggestions(false);
    }
  }

  componentDidMount() {
    document.addEventListener('keypress', this._handleKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('keypress', this._handleKeyPress);
  }

  render() {
    const { search, placeholder } = this.props;

    return (
      <div className={this.props.wrapperClass || 'search-wrapper'}>
        <input placeholder={ placeholder || 'Search' }
               className={this.props.inputClass ?
                 this.props.inputClass + ' search-input' :
                 'search-input'}
               value={this.props.value ? this.props.value.get('name') : search.get('currentSearchTerm')}
               onChange={this.onChange.bind(this)}
               type='text' />

         <Suggestions
           {...this.props}
           showSuggestions={this.state.showSuggestions}
           toggleSuggestions={this._toggleSuggestions}
           createListingCopy={this.props.createListingCopy}
          />
      </div>
    );
  }
}

Search.propTypes = {
  customer: PropTypes.object.isRequired,
  search: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  wrapperClass: PropTypes.string,
  createListingCopy: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Search/Search.js